module.exports = __webpack_public_path__ + "static/media/ash-logo.151a281e.JPG";